module.exports = __webpack_public_path__ + "media/images/flags/64/Bahamas-38d5e80ccfdd5cc34b9d0d23afdcfa9d.png";